import React from 'react';
import { Card } from '../ui/card';
import cardStyles from './CftcCards.module.css';

type DeskReadCardProps = {
  title?: string;
  lines: string[];
};

const DeskReadCard: React.FC<DeskReadCardProps> = ({ title = 'Desk Read', lines }) => (
  <Card className={cardStyles.card}>
    <div className={cardStyles.cardTitle}>{title}</div>
    <ul className={cardStyles.cardList}>
      {lines.map((line) => (
        <li key={line} className={cardStyles.cardRow}>
          <span className={cardStyles.bullet} />
          <span>{line}</span>
        </li>
      ))}
    </ul>
  </Card>
);

export default DeskReadCard;
